import { filter, map, Subject } from 'rxjs';
import {
  getCookie,
  getData,
  metricsLog,
  setData,
} from './utils';
import { PixelsVideoEvent } from '../../constants/Video';

export const adSkipped = (sub: Subject<[string, any]>, pixelsUUIDKey: string, typeOfIntegration: string) => {
   const adPlayer$ = sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.AD_REQUEST, PixelsVideoEvent.AD_STARTED,
      PixelsVideoEvent.FIRST_FRAME,
      PixelsVideoEvent.AD_SKIPPED,
    ].includes(type as PixelsVideoEvent)),
    map(([type]) => {
       switch (type) {
        case PixelsVideoEvent.AD_SKIPPED:
          return true;
        default:
          return false;
      }
    }),
  );

  adPlayer$.subscribe((value) => {
    const uuid = getCookie(pixelsUUIDKey);
    const storageKey = `${uuid}-${typeOfIntegration}`;
    const data = getData(storageKey);

    metricsLog(`Ad pos: ${value}`);

    setData(storageKey, {
      ...data,
      skipped: {
        value,
      }
    });
  });
};
